function NoPage() {
    return (
        <div className="nopage">
            No Page found
        </div>
    )
}

export default NoPage;